// Preprocess Zod p/ env vars: no Swarm/compose, var não definida interpola
// como "" no stack — tratar string vazia como ausente para `.optional()` e
// `.default()` funcionarem. Consumido pelos schemas de env (worker, web).
export const emptyToUndefined = (v: unknown) => (v === "" ? undefined : v);
